import { create } from 'zustand';

interface GlobalStore {
  // Auth Modal state
  isAuthModalOpen: boolean;
  openAuthModal: () => void;
  closeAuthModal: () => void;
}

export const useGlobalStore = create<GlobalStore>()((set) => ({
  // Auth Modal methods
  isAuthModalOpen: false,
  openAuthModal: () => set({ isAuthModalOpen: true }),
  closeAuthModal: () => set({ isAuthModalOpen: false }),
}));
